var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"shareCoupon-error"},[_vm._m(0),_c('div',{staticClass:"error-txt"},[_vm._v("网络不太顺畅哦，请再次刷新或者检查网络")]),_c('div',{staticClass:"error-again",on:{"click":function($event){return _vm.goCoupon()}}},[_vm._v("重新加载")])])
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"error-pic"},[_c('img',{attrs:{"src":"//static.yunjiweidian.com/qnUpload/frontend/logo/icon_network_error.png"}})])
}]

export { render, staticRenderFns }